@import 'styles/mixins';

.root {
  display: flex;
  align-items: center;
  gap: 5px;

  @include for-phone-only {
    span {
      color: var(--dark-60) !important;
      font-weight: 400 !important;
      line-height: normal !important;
      letter-spacing: 0.24px !important;
    }
  }
}
